import { render, staticRenderFns } from "./ReportComponent.vue?vue&type=template&id=51ad878d&scoped=true&"
import script from "./ReportComponent.vue?vue&type=script&lang=js&"
export * from "./ReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportComponent.vue?vue&type=style&index=0&id=51ad878d&lang=scss&scoped=true&"
import style1 from "./ReportComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ad878d",
  null
  
)

export default component.exports